import { render } from "./FetchingView.vue?vue&type=template&id=78e3e3a8&scoped=true&ts=true"
import script from "./FetchingView.vue?vue&type=script&lang=ts"
export * from "./FetchingView.vue?vue&type=script&lang=ts"

import "./FetchingView.vue?vue&type=style&index=0&id=78e3e3a8&scoped=true&lang=css"

import exportComponent from "/home/runner/work/olaria-preco/olaria-preco/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78e3e3a8"]])

export default __exports__